import axios, { AxiosError, AxiosResponse } from 'axios'
import { MUserProfile } from '@Models/client/profile.model'
import { IUpdate } from '@Models/common.model'
import * as Redux from 'redux'
import AuthAction from '@Stores/auth/auth.action'
import { AuthActionTypes } from '@Stores/auth/auth.action-types'
import SharedActions from '@SharedActions/loading.action'
import { APIServices } from '@Services/api.service'
import { ToastServices } from '@Services/toast.service'
import { MCity, MCountry, MState } from '@Models/auth.model'
import { ClientActionTypes } from '../client.action-types'

const PROFILE = `${APIServices.apiUrlV1}/admin/users/profile`
const CHANG_PASSWORD = `${APIServices.apiUrlV1}/users/change-password`

const getProfile = () => {
    return (dispatch: Redux.Dispatch) => {
        dispatch(SharedActions.setClientLoading(true) as any)
        APIServices.axiosConfig()
        axios
            .get(PROFILE)
            .then((response: AxiosResponse) => {
                const tempReground = response?.data?.residences
                    ?.filter((item: any) => item?.type === 'PR')
                    ?.map((item: any) => {
                        return {
                            countries: [new MCountry(item?.country)],
                            states: [new MState(item?.state)],
                            cities: [new MCity(item?.city)],
                        }
                    })
                const tempCountries = tempReground?.map(
                    (item: any) => item?.countries
                )
                const tempStates = tempReground?.map(
                    (item: any) => item?.states
                )
                const tempCities = tempReground?.map(
                    (item: any) => item?.cities
                )

                dispatch({
                    type: AuthActionTypes.GET_DYNAMIC_PR_COUNTRIES,
                    payload: tempCountries,
                })

                dispatch({
                    type: AuthActionTypes.GET_DYNAMIC_PR_STATES,
                    payload: tempStates,
                })

                dispatch({
                    type: AuthActionTypes.GET_DYNAMIC_PR_CITIES,
                    payload: tempCities,
                })

                const payload = new MUserProfile(response?.data)
                dispatch({ type: ClientActionTypes.GET_PROFILE, payload })
                dispatch(SharedActions.setClientLoading(false) as any)
            })
            .catch((errors: AxiosError) => {
                const message = errors?.response?.data?.message
                ToastServices.error(message || 'Unspecific errors!')
                dispatch(SharedActions.setClientLoading(false) as any)
            })
    }
}

const updateProfile = (payload: any) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(SharedActions.setClientLoading(true) as any)
            axios
                .put(PROFILE, payload)
                .then((response: AxiosResponse) => {
                    const profileImage = payload?.profileImage
                    const result = { ...response?.data?.data, profileImage }
                    ToastServices.success('Profile updated')
                    dispatch({
                        type: AuthActionTypes.UPDATE_PROFILE,
                        payload: result,
                    })
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const changePassword = (payload: IUpdate<any>) => {
    return (dispatch: Redux.Dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch(SharedActions.setClientLoading(true) as any)
            axios
                .put(CHANG_PASSWORD, payload?.payload)
                .then((response: AxiosResponse) => {
                    ToastServices.success('Password changed')
                    dispatch(AuthAction.logout() as any)
                    dispatch(SharedActions.setClientLoading(false) as any)
                    resolve(response)
                })
                .catch((errors: AxiosError) => {
                    const message = errors?.response?.data?.message
                    ToastServices.error(message || 'Unspecific errors!')
                    dispatch(SharedActions.setClientLoading(false) as any)
                    reject(errors)
                })
        })
    }
}

const ClientProfileActions = {
    getProfile,
    updateProfile,
    changePassword,
}

export default ClientProfileActions
